export default {
    API_ADDRESS: 'https://api.hanssen.io/v1',
    FACEBOOK_APP_ID: '1854513794601024'
}


// WEBPACK FOOTER //
// ./src/config.js